module.exports = __webpack_public_path__ + "img/checkrouge_on.5eaf3952.gif";